export const fields = {
  hasPrescriptionScanner: "hasPrescriptionScanner",
  orderDeliveryServices: "orderDeliveryServices", // Record<string, boolean> read from referential
  socialMediaUrls: "socialMediaUrls", // Record<string, string> read from referential
  websiteService: "websiteService",
  healthAppointmentUrl: "healthAppointmentUrl",
  hasWebsite: "hasWebsite",
  websiteSiteUrl: "website.siteUrl",
  websiteWebsiteService: "website.websiteService",
} as const
